const getters = {
  classes: state => {
    if (!state.classes) {
      return [];
    }

    return state.classes.map(classItem => ({
      ...classItem,
      uniqueId: classItem.id,
    }));
  },

  featureGroups: state => state.featureGroups || [],

  hasFiltersApplied: state => Object.values(state.filters).filter(Boolean).length > 0,

  filtersApplied: state => Object.values(state.filters),

  levels: state => state.levels || [],

  organizations: state => state.organizations || [],

  teachers: state => {
    if (!state.teachers) {
      return [];
    }

    return state.teachers.slice().sort((a, b) => a.name.localeCompare(b.name));
  },
  visibleColumns: state => state.columns.filter(column => column.showColumn),
  classTypes: state => state.classTypes || [],
  classPolicies: state => state.classPolicies || [],
};

export default getters;
